import script from "./CardHabitacion.vue?vue&type=script&setup=true&lang=js"
export * from "./CardHabitacion.vue?vue&type=script&setup=true&lang=js"

import "./CardHabitacion.vue?vue&type=style&index=0&id=4a037b15&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a037b15"]])

export default __exports__